<template>
  <div>
    <o-table ref="tableList" :enable-delete="false" :enable-edit="false"
             :title="$t('sandoz.pass_through_blacklist')" :url="'/api/sandoz/pass_through_blacklist?include=contact'">
      <template slot="filter">
        <o-filter :filter-cacheable="true" v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)">
          <o-filter-text :title="$t('sandoz.customer_external_id')" column="external_id"></o-filter-text>
        </o-filter>
      </template>
      <template slot="head">
        <o-table-header column="year_month">{{ $t('sandoz.customer_external_id') }}</o-table-header>
        <o-table-header :sortable="false">{{ $t('sandoz.full_name') }}</o-table-header>
      </template>
      <template slot="body" slot-scope="props">
        <td>{{ props.item.external_id }}</td>
        <td>{{ props.item.contact ? props.item.contact.data.full_name : '' }}</td>
      </template>
      <template slot="body-controls" slot-scope="props">
        <td class="text-right">
          <o-button class="mr-1" variant="outline-secondary" @click.prevent="ignoreRecord(props.item)">
            <fa icon="times"/>
          </o-button>
        </td>
      </template>
    </o-table>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button variant="outline-primary" @click.prevent="back">{{ $t('core.back') }}</o-button>
      </div>
    </o-action-toolbar>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  mounted() {
  },
  methods: {
    ignoreRecord(item) {
      var self = this
      if (window.confirm('Are you sure you want to ignore this record?')) {
        axios.delete('/api/sandoz/pass_through_blacklist/' + item.id,).then((response) => {
          self.$refs.tableList.search()
        })
      }
    },
    back() {
      this.$router.back()
    }
  }
}
</script>
